import Translation from './translation'
import Location from './location.js'

export default class Link extends Translation
{
    get active_ar() {
        return this.locales.includes('ar');
    }

    get active_en() {
        return this.locales.includes('en');
    }
    
    get active_fa() {
        return this.locales.includes('fa');
    }

    constructor(link){
        super()
        this.id             = 0
        
        this.locales        = []
        
        this.title_ar       = ''
        this.title_en       = ''
        this.title_fa       = ''
        
        this.description_ar = ''
        this.description_en = ''
        this.description_fa = ''

        this.url_ar         = ''
        this.url_en         = ''
        this.url_fa         = ''

        this.locations      = []
        this.icon           = ''
        this.published      = false

        this.tags           = []

        this.map(link)
        this.init()
    }

    map(link){
        if(link == undefined) return
        
        this.id             = link.id
        this.icon           = link.icon

        this.locations      = link.locations && Array.isArray(link.locations) ? link.locations.map((a)=>new Location(a)) : this.locations

        this.published      = link.published_at != null
        this.created_at     = link.created_at  
        this.updated_at     = link.updated_at  
        this.published_at   = link.published_at  

        for (let locale in link.translations) {
            this['title_' + locale] = link.translations[locale].title
            this['description_' + locale] = link.translations[locale].description
            this['url_' + locale] = link.translations[locale].url
            this.locales.push(locale);
        }
        this.setLocale(this.locales)
    }

    toFormData(){
        let fData = new FormData()
        
        for(let locale of this.locales){

            fData.append('translation['+ locale +'][title]', this['title_'+ locale]);
            fData.append('translation['+ locale +'][description]', this['description_'+ locale]);
            fData.append('translation['+ locale +'][url]', this['url_'+ locale]);
        }
        
        fData.append('published', Number(this.published));
        fData.append('icon', this.icon);
        
        this.locations.forEach((location, index)=>fData.append('locations['+ index +']', location.id))

        return fData
    }
}
